import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import {
  addCoverCancelFiltersSchema,
  AddCoverCancelLessonView
} from '@/modules/coveredAndCancelledLessons'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute(
  '/_auth/covered-and-cancelled-lessons/add-cover-cancel'
)({
  validateSearch: addCoverCancelFiltersSchema,
  component: AddCoverCancelLessonView,
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.cover-cancel-lesson', { ns: 'coveredCancelledLessons' })
    ])
})
